import React from 'react';
import Webcam from "react-webcam";
import Popup from 'reactjs-popup';

function NonRandomNumber() {
    return (
      <div className="App">
        <header className="App-header">
        Random Number Generator

<Popup
    trigger={<button className="button"> Instructions </button>}
    modal
    nested
    defaultOpen
  >
    {close => (
      <div className="modal">
        <div className="header"> <strong> Random Number Generator </strong> </div>
        <div className="content">
          {' '}
          We used a state-of-the art random number generator, one that measures quantum fluctuations, entanglements, solar flares, and atmospheric readings from the past several hundred years to generate a truly random number. 
          <br />
          <br />

          The amount of computation required for this was absolutely staggering, so we were only able to run it once.
          <br />
          <br />

          Thankfully, the number that we generated is still preserved for all of us to look at.
          <br />
          <br />

        </div>
        <div className="actions">
          <button
            className="button"
            onClick={() => {
              console.log('modal closed ');
              close();
            }}
          >
            Let's Get Started!
          </button>
        </div>
      </div>
    )}
  </Popup>
  <Popup trigger={<button className="button"> Generate Number </button>} modal>
          <span class = "modal"> 3 </span>
  </Popup>
  </header>
  </div>

    );
}


  
  export default NonRandomNumber;
  